<template>
    <div>
        <el-card>
            <div class="boxClass">
                <span>细化变更</span>
                <div>
                    <router-link :to="{ path: '/changeStatusList'}">
                        <span>变更RFC状态实时汇总</span>
                    </router-link>
                    <router-link :to="{ path: '/changeStatusStatis'}">
                        <span>变更状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/groupeChangeStatus'}">
                        <span>组别变更状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/changeRFCNum'}">
                        <span>变更RFC数量</span>
                    </router-link>
                    <router-link :to="{ path: '/changeRFCNumStatus'}">
                        <span>变更RFC数量状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/changeRFCNumGroupe'}">
                        <span>变更RFC数量组别状态统计</span>
                    </router-link>
                     <router-link :to="{ path: '/changeRFCCloseNum'}">
                        <span>变更RFC的关闭数量</span>
                    </router-link>
                    <router-link :to="{ path: '/changeRFCCloseNumStatus'}">
                        <span>变更RFC关闭数量状态统计</span>
                    </router-link>
                    <router-link :to="{ path: '/changeRFCCloseNumGroupe'}">
                        <span>变更RFC关闭数量组别统计</span>
                    </router-link>
                </div>
                
            </div>
        </el-card>
    </div>
</template>

<script>
    
    export default {
        
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .boxClass{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        &>span{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        &>div{
            display: flex;
            flex-wrap:wrap;
            span{
                color:gray!important;
                margin-right: 30px;
            }
        }
    }
</style>